'use strict';

var React = require('react');
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');
var cx = require('classnames');
var i18n = require('../../utils/i18n');
var history = require('./../../flow/history');
var Analytics = require('../../utils/Analytics');

module.exports = React.createClass({

    mixins: [i18n('common/modal')],

    propTypes: {
        applicationData: React.PropTypes.object.isRequired,
        features: React.PropTypes.object.isRequired,
        startPage: React.PropTypes.func.isRequired,
        startPageProps: React.PropTypes.object,
        initHistoryPages: React.PropTypes.func,
        terminalPages: React.PropTypes.array,
        noBackBtnPages: React.PropTypes.array,
        hideFeedbackLink: React.PropTypes.array,
        fullScreenPages: React.PropTypes.array,
        noCloseBtnPages: React.PropTypes.array,
        hasCloseBtnPages: React.PropTypes.array,
        onClose: React.PropTypes.func,
        onBack: React.PropTypes.func // used by direct deposit page. To be replaced with return uri.
    },

    launchFeedback: function (e) {
        e.preventDefault();
        if (typeof window.launchOpinionLabFeedback === 'function') {
            Analytics.trackLink({ link: 'feedbackLink' });
            window.launchOpinionLabFeedback(e);
        }
    },

    getDefaultProps: function () {
        return {
            isCloseable: true,
            terminalPages: [],
            noBackBtnPages: [],
            hideFeedbackLink: [],
            fullScreenPages: [],
            noCloseBtnPages: [],
            hasCloseBtnPages: []
        };
    },

    getInitialState: function () {
        var hist = history(this.props.startPage, this.props.startPageProps);
        this.history = this.props.initHistoryPages ? this.props.initHistoryPages(hist) : hist;

        this.flow = {
            back: this.back,
            push: this.push,
            wrapAjax: this.wrapAjax,
            jumpTo: this.jumpTo
        };

        return {
            isFetching: false,
            isOpen: true,
            currentPage: this.history.getCurrentNode(),
            transition: 'swipeForward'
        };
    },

    syncState: function (transition) {
        var nextPage = this.history.getCurrentNode();
        var currentPage = this.state.currentPage;
        var pageRef = this.pageRef;

        if (currentPage !== nextPage) {
            if (pageRef.getPreservedState) {
                currentPage.state = pageRef.getPreservedState();
            } else {
                // NOTE: since setState is asynchronous, if current page updates its state just before unmounting,
                // the change won't be reflected in its state immediately (i.e. we can't directly use `pageRef.state`).
                // `setState` can take a callback, which will be given the previous state. Fortunately, this previous state
                // is always up-to-date. Here we make use of that.
                pageRef.setState(function (state) {
                    currentPage.state = state;
                    return state;
                });
            }

            this.setState({
                currentPage: nextPage,
                transition: transition
            });
        }
    },

    history: {},

    push: function (page, props) {
        this.history.addPage(page, props);
        this.syncState('swipeForward');
    },

    beforeFetch: function () {
        this.setState({ isFetching: true });
    },

    afterFetch: function () {
        this.setState({ isFetching: false });
    },

    handleRedirect: function (fn) {
        var that = this;
        return function (res) {
            if (res && res.redirectTo) {
                Analytics.trackPage({id: 'stepUpRedirect', data: that.props});
                window.location.href = res.redirectTo;
                return;
            }
            that.afterFetch();
            fn.apply(null, arguments);
        };
    },

    wrapAjax: function (fn) {
        var beforeFetch = this.beforeFetch;
        var afterFetch = this.afterFetch;
        var handleRedirect = this.handleRedirect;

        return function () {
            var args = Array(arguments.length);
            var i = 0;
            // copy all except the last 2 callbacks
            for (; i < arguments.length - 2; ++i) {
                args[i] = arguments[i];
            }

            var onSuccess = arguments[i];
            var onFailure = arguments[i + 1];

            args[i] = function () {
                var fn = handleRedirect(onSuccess);
                fn.apply(null, arguments);
            };

            args[i + 1] = function () {
                afterFetch();
                onFailure.apply(null, arguments);
            };

            beforeFetch();
            return fn.apply(null, args);
        };
    },

    jumpTo: function (page) {
        if (this.history.contains(page)) {
            var currentNode = this.history.getCurrentNode();
            var currentIndex = this.history.getCurrentIndex();
            while (currentIndex > 0) {
                currentIndex = this.history.getCurrentIndex();
                if (page === currentNode.page) {
                    break;
                }
                this.history.back();
                currentNode = this.history.getCurrentNode();
            }
            this.syncState('swipeForward');
            return true;
        } else {
            return false;
        }
    },

    back: function () {
        if (this.props.onBack) {
            this.props.onBack();
        } else if (this.state.currentPage.prev) {
            this.history.back();
            this.syncState('swipeBackward');
        } else if (this.props.applicationData.returnUri) {
            window.location.href = this.props.applicationData.returnUri;
        }
    },

    forward: function () {
        this.history.forward();
        this.syncState('swipeForward');
    },

    handleBackClick: function () {
        Analytics.trackLink({ link: 'back' });
        this.back();
    },

    renderCurrentPage: function (props) {
        if (this.props.features.log_application_state && !this.appDataLogged) {
            this.appDataLogged = true;
            console.info('[bankingbundle] applicationData: ', this.props.applicationData);
        }

        return <ReactCSSTransitionGroup
            transitionName={this.state.transition}
            transitionEnterTimeout={300}
            transitionLeaveTimeout={300}>
            <this.state.currentPage.page
                ref={function (r) {
                    if (r) {
                        this.pageRef = r;
                    }
                }.bind(this)}
                key={this.history.getCurrentIndex()}
                flow={this.flow}
                preservedState={this.state.currentPage.state}
                isFetching={this.state.isFetching}
                {...props}
                {...this.state.currentPage.props} />
        </ReactCSSTransitionGroup>;
    },

    canGoBack: function () {
        // TODO: onBack is used by direct deposit page. To be replaced with return uri.

        const currentPage = this.state.currentPage;
        const isTerminalPage = this.props.terminalPages.indexOf(currentPage.page) >= 0;
        const isStartPage = this.props.startPage === currentPage.page;

        const hasOnBack = this.props.onBack;
        const hasHistoryBack = !!currentPage.prev && !isTerminalPage;
        const hasReturnUri = !!this.props.applicationData.returnUri && isStartPage;

        const backBtnHidden = this.props.noBackBtnPages.indexOf(currentPage.page) >= 0;

        return !backBtnHidden && (hasOnBack || hasHistoryBack || hasReturnUri);
    },

    shouldShowCloseButton: function () {
        // hide close button on mobile webview
        if (this.props.applicationData.isMobileNative) {
            return false;
        }

        var curPage = this.state.currentPage.page;

        // noCloseBtnPages overrides hasCloseBtnPages
        if (this.props.noCloseBtnPages.length > 0) {
            return this.props.noCloseBtnPages.indexOf(curPage) < 0;
        } else if (this.props.hasCloseBtnPages.length > 0) {
            return this.props.hasCloseBtnPages.indexOf(curPage) > -1;
        }

        // show close button if neither noCloseBtnPages or hasCloseBtnPages is specified
        return true;
    },

    showFeedbackLink: function () {
        var currentPage = this.state.currentPage;
        return this.props.hideFeedbackLink.indexOf(currentPage.page) >= 0;
    },

    shouldShowFullScreen: function () {
        var currentPage = this.state.currentPage;
        return this.props.fullScreenPages.indexOf(currentPage.page) >= 0;
    },

    close: function () {
        Analytics.trackLink({ link: 'closeModal' });
        this.setState({ isOpen: false });

        const returnUri = this.props.applicationData.returnUri;
        if (returnUri) {
            window.location.href = returnUri;
        } else if (this.props.onClose) {
            this.props.onClose();
        } else {
            window.location.href = '/myaccount';
        }
    },

    renderFeedback: function () {
        if (!this.props.applicationData.isMobileNative && !this.showFeedbackLink()) {
            return (
                <div className="modal-pp-feedback hidePrintFormView">
                    <a onClick={this.launchFeedback}>
                        <img src="https://www.paypalobjects.com/digitalassets/c/consumer/bundle/icons/icFeedback24.svg" />
                        {this.i18n('modal.feedback')}
                    </a>
                </div>
            );
        }
    },

    render: function () {
        var isHeaderEmpty = !this.canGoBack() && !this.shouldShowCloseButton();
        return (
            <div className={cx('vx_modal-flow', 'vx_modalPrepToOpen', {'vx_modalIsOpen': this.state.isOpen})}>
                <div className={cx('vx_modal-wrapper', {
                    'vx_modal-wrapper_fullScreen': this.shouldShowFullScreen(),
                    'vx_has-spinner-large': this.state.isFetching,
                    'vx_modal-no-header': isHeaderEmpty})}>
                    <div className={
                        cx(
                            'vx_modal-inner-wrapper',
                            {'tax_refund-wrapper': this.props.features.upgrade_tax_refund}
                        )
                    }>
                        {this.canGoBack() &&
                            <button id="back-btn" className="vx_backBtn vx_backBtn_flow _demo_stepBackward" onClick={this.handleBackClick}>{this.i18n('modal.back')}</button>}

                        {this.shouldShowCloseButton() &&
                            <button id="close-btn" className="vx_modal-dismiss_x-trigger" onClick={this.close}>
                                <span className="vx_a11yText">{this.i18n('modal.close')}</span>
                            </button>}

                        <this.props.rootComponent
                            flow={this.flow}
                            renderCurrentPage={this.renderCurrentPage}
                            {...this.props.applicationData} />
                    </div>
                    {this.renderFeedback()}
                    {!this.shouldShowFullScreen() && <div className="modal-pp-logo" />}
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./public/js/components/flow/Modal.react.js